/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "skills";

export interface InverterResultData {
}

export interface InverterActionStateData {
}

function createBaseInverterResultData(): InverterResultData {
  return {};
}

export const InverterResultData = {
  encode(_: InverterResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): InverterResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInverterResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): InverterResultData {
    return {};
  },

  toJSON(_: InverterResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<InverterResultData>, I>>(base?: I): InverterResultData {
    return InverterResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InverterResultData>, I>>(_: I): InverterResultData {
    const message = createBaseInverterResultData();
    return message;
  },
};

function createBaseInverterActionStateData(): InverterActionStateData {
  return {};
}

export const InverterActionStateData = {
  encode(_: InverterActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): InverterActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseInverterActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): InverterActionStateData {
    return {};
  },

  toJSON(_: InverterActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<InverterActionStateData>, I>>(base?: I): InverterActionStateData {
    return InverterActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<InverterActionStateData>, I>>(_: I): InverterActionStateData {
    const message = createBaseInverterActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
